export default {
  nav: {
    portfolio: 'Portfolio',
    services: 'Services',
    howWeWork: 'How We Work',
    about: 'About',
    team: 'Team',
    contact: 'Contact',
    startProject: 'Start a project',
  },
  hero: {
    badge: 'Ukrainian IT Company',
    title1: 'Build your',
    title2: 'business',
    withUs: 'with us',
    subtitle: 'We automate, build, and scale your digital products from bots to full platforms',
    startProject: 'Start a project',
    viewPortfolio: 'View portfolio',
    projects: 'Projects',
    years: 'Years',
    satisfaction: 'Satisfaction',
  },
  portfolio: {
    title1: "What we've",
    title2: 'built',
    subtitle: 'Explore our latest projects — from open source frameworks to fintech platforms',
    project_aiober_desc: 'Python framework for scalable Viber bots with async support and easy API integration.',
    project_karum_desc: 'Financial tracker that combines crypto wallets and bank accounts in one unified dashboard.',
    project_bookflow_desc: 'Booking system for services with appointments, scheduling, and automated reminders.',
    project_allix_desc: 'Something big is coming. Stay tuned for our next breakthrough project.',
    link_github: 'GitHub',
    link_telegram: 'Telegram',
  },
  services: {
    title1: 'Our',
    title2: 'services',
    subtitle: 'We offer end-to-end solutions to power your digital transformation',
    getStarted: 'Get started',
    bots_title: 'Bot Development',
    bots_desc: 'Telegram, Viber, Discord bots with custom logic and integrations.',
    automation_title: 'Business Automation',
    automation_desc: 'Save time and reduce manual work with intelligent automated workflows.',
    webdev_title: 'Web Development',
    webdev_desc: 'Websites, platforms, online stores with modern tech stacks.',
    hosting_title: 'Hosting & Support',
    hosting_desc: 'We host and support your projects so you can focus on growth.',
  },
  howWeWork: {
    title1: 'How we',
    title2: 'work',
    subtitle: 'A proven process from idea to launch and beyond',
    step1_title: 'Planning & Requirements',
    step1_desc: 'We start by understanding your business needs, goals, and technical constraints.',
    step2_title: 'Architecture & System Design',
    step2_desc: 'We design scalable, maintainable architecture tailored to your specific requirements.',
    step3_title: 'UI/UX Design',
    step3_desc: 'We create intuitive, visually stunning interfaces that users love.',
    step4_title: 'Development',
    step4_desc: 'We build your product with clean, efficient code using modern technologies.',
    step5_title: 'Testing & QA',
    step5_desc: 'Rigorous testing ensures your product works flawlessly across all scenarios.',
    step6_title: 'Deployment',
    step6_desc: 'We deploy to production with monitoring, CI/CD, and zero-downtime strategies.',
    step7_title: 'Support & Scaling',
    step7_desc: 'Continuous support, performance monitoring, and scaling as your business grows.',
  },
  about: {
    badge: 'About us',
    title1: 'Ukrainian IT',
    title2: 'with a mission',
    p1: 'Quaron Software is a Ukrainian IT company focused on automation, bots, and scalable software solutions. We help businesses optimize processes, reduce costs, and build modern digital products.',
    p2: 'Our team combines deep technical expertise with a passion for creating tools that make a real difference. From building custom Telegram and Viber bots to developing full-scale fintech platforms, we treat every project as an opportunity to innovate.',
    p3: 'We believe in open source, transparency, and long-term partnerships with our clients. Whether you are a startup looking to automate operations or an established business ready to modernize — we are here to help.',
    projectsDelivered: 'Projects delivered',
    yearsInBusiness: 'Years in business',
    teamMembers: 'Team members',
    quote: "We don't just write code. We solve real business problems with software that is reliable, scalable, and beautiful.",
    companyName: 'Quaron Software',
    companySubtitle: 'Ukrainian IT Company',
    missionTitle: 'Our Mission',
    mission1: 'Deliver high-quality software on time',
    mission2: 'Empower businesses through automation',
    mission3: 'Build long-term client partnerships',
    mission4: 'Contribute to the open source community',
  },
  team: {
    title1: 'Our',
    title2: 'team',
    subtitle: 'The people behind Quaron Software',
    nazar: 'Nazar',
    roman: 'Roman',
    nickname: 'Nickname',
    role_nazar: 'Founder & Lead Engineer',
    role_roman: 'Co-Founder & Designer',
  },
  moneyButton: {
    zone: 'Mini Game Zone',
    balance: 'Balance',
    perClick: 'Per click',
    perSecond: 'Per second',
    clicks: 'Clicks',
    money: 'Money',
    btc: 'BTC',
    upgrade_cursor: 'Better Cursor',
    upgrade_bot: 'Auto Bot',
    upgrade_server: 'Server Farm',
    upgrade_ai: 'AI Agent',
    perClickLabel: '/click',
    perSecondLabel: '/sec',
    owned: 'x',
  },
  contact: {
    title1: "Let's",
    title2: 'build',
    title3: 'something',
    subtitle: 'Have a project in mind? Drop us a message and we will get back to you within 24 hours.',
    nameLabel: 'Your name',
    emailLabel: 'Email',
    messageLabel: 'Message',
    namePlaceholder: 'John Doe',
    emailPlaceholder: 'john@example.com',
    messagePlaceholder: 'Tell us about your project...',
    sendMessage: 'Send message',
    messageSent: 'Message sent!',
    email: 'quaronsoftware@proton.me',
    telegram: '@notGucul',
  },
  footer: {
    description: 'Ukrainian IT company focused on automation, bots, and scalable software solutions.',
    navigation: 'Navigation',
    moneyButton: 'Money Button',
    services: 'Services',
    botDev: 'Bot Development',
    bizAuto: 'Business Automation',
    webDev: 'Web Development',
    hosting: 'Hosting & Support',
    copyright: 'Quaron Software. All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
  notFound: {
    title: 'Page Not Found',
    subtitle: 'The page you are looking for does not exist or has been moved.',
    backHome: 'Back to Home',
  },
};